import { useEffect, useRef } from 'react'

import { useAuthenticatedFirebaseUser } from '@/auth/useFirebaseUser'
import { useNotificationSound } from '@/hooks/useNotificationSound'

import { type SupportRequestDocument } from './types'

const latestReplyAt = (requests: ReadonlyArray<SupportRequestDocument>) =>
  Math.max(0, ...requests.map(({ lastAgentReplyAt }) => lastAgentReplyAt?.getTime() ?? 0))

export const useSupportRequesterSound = (
  requests: ReadonlyArray<SupportRequestDocument>,
  { isLoaded, panelOpen }: { isLoaded: boolean; panelOpen: boolean }
) => {
  const { playNotificationSound } = useNotificationSound()
  const { regionId } = useAuthenticatedFirebaseUser()
  const heardUpTo = useRef<number | null>(null)

  useEffect(() => {
    if (!isLoaded) {
      return
    }
    const latest = latestReplyAt(requests)
    if (heardUpTo.current === null) {
      heardUpTo.current = latest
      return
    }
    if (latest <= heardUpTo.current) {
      return
    }
    heardUpTo.current = latest
    if (!panelOpen) {
      playNotificationSound('support', `requester:${regionId ?? ''}:${latest}`)
    }
  }, [requests, isLoaded, panelOpen, playNotificationSound, regionId])
}
